export const APIKeys = {
  GPTAPIKey: '',
  FalAPIKey: '',
};
